import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // For global styles (optional)
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { OrganizationProvider } from './contexts/OrganizationContext';

import '@fontsource/poppins'; // Defaults to 400 weight
import '@fontsource/poppins/300.css'; // Light weight
import '@fontsource/poppins/500.css'; // Light weight
import '@fontsource/poppins/700.css'; // Bold weight

import '@fontsource/roboto'; // Defaults to 400 weight
import '@fontsource/roboto/300.css'; // Light weight
import '@fontsource/roboto/500.css'; // Light weight
import '@fontsource/roboto/700.css'; // Bold weight

// Create the root of the application and render it into the DOM
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <OrganizationProvider>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </OrganizationProvider>
  </React.StrictMode>
);
